/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 *
 * @export
 * @interface BaseEventState
 */
export interface BaseEventState {
  /**
   *
   */
  state: EventStateEnum;
  /**
   *
   */
  stateDetail: any | null;
}

/**
 * Check if a given object implements the BaseEventState interface.
 */
export function instanceOfBaseEventState(value: object): value is BaseEventState {
  if (!("state" in value) || value["state"] === undefined) return false;
  if (
    (!("stateDetail" in (value as Record<string, any>)) &&
      !("state_detail" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["stateDetail"] === undefined &&
      (value as Record<string, any>)["state_detail"] === undefined)
  )
    return false;
  return true;
}

export function BaseEventStateFromJSON(json: any): BaseEventState {
  return BaseEventStateFromJSONTyped(json, false);
}

export function BaseEventStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BaseEventState {
  if (json == null) {
    return json;
  }
  return {
    state: EventStateEnumFromJSON(json["state"]),
    stateDetail: json["state_detail"],
  };
}

export function BaseEventStateToJSON(json: any): BaseEventState {
  return BaseEventStateToJSONTyped(json, false);
}

export function BaseEventStateToJSONTyped(
  value?: BaseEventState | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    state: EventStateEnumToJSON(value["state"]),
    state_detail: value["stateDetail"],
  };
}
